.file {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.name {
  overflow: hidden;
  color: var(--ink);
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.none {
  color: var(--muted);
}

.primary {
  /* Also used on a link (Review): a link is underlined by the page's own rule, and the underline's pale
     colour under white text is the pixel the contrast gate reads (4.42:1). A control wears no underline. */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--accent);
  border-radius: var(--radius-ctl);
  background: var(--accent);
  color: var(--on-fill);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.primary:hover:not(:disabled) {
  background: var(--accent-h);
}

.primary:disabled {
  border-color: var(--btn-off-bg);
  background: var(--btn-off-bg);
  color: var(--btn-off-ink);
  cursor: default;
}

.secondary {
  height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.secondary:hover:not(:disabled) {
  background: var(--panel-2);
}

/* A link drawn as a button (the Census link beside the filter line). */
a.secondary {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

/* One column of buttons of one width: stacked in a narrow cell they used to be as wide as their own
   words, so the right edges of "Declare nil" and "Withdraw nil" fell short of "Show what arrived"
   (alignment audit, 2026-11-03). */
.rowActions {
  display: inline-grid;
  grid-template-columns: max-content;
  justify-items: stretch;
  gap: 6px;
}

.verdict {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.link {
  color: var(--accent);
  font-weight: 600;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.formField {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: var(--ink-2);
  font-weight: 600;
}

.formField textarea {
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  padding: 8px;
}
